import { Users } from 'lucide-react';

import { EmptyResult } from '@/components/empty-result';

export const MemberEmptyResult = () => (
  <EmptyResult
    icon={<Users className="h-12 w-12 text-muted-foreground/40" />}
    title="No members found"
  />
);
